// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Frame_wrapper__1DPAn","divider":"Frame_divider__1e-CH","left":"Frame_left__1zWKu","right":"Frame_right__399qp","illu":"Frame_illu__1JOt-"};